import { Container, SectionFull } from "components"
import Img from "gatsby-image"
import LanguageContext from "logic/context/language"
import useTilesStagger from "logic/hooks/use-tiles-stagger"
import { Services } from "model/content"
import React, { FunctionComponent, useContext, useRef } from "react"
import styled from "styled-components"
import tw from "twin.macro"
import { AnchorToGoTo } from "components/AnchorToGoTo"
import HomeTile from "./HomeTile"

const WhatWeDoSection = styled(SectionFull)`
  ${tw`overflow-hidden`}
`

const WhatWeDoContent = styled.div`
  ${tw`relative py-16 lg:py-24 m-auto md:w-11/12 z-20`}
`

const DescriptionContainer = styled.div`
  ${tw`flex flex-col justify-between`}
`

const Heading = styled.h2`
  ${tw`font-condensed text-6xl leading-none uppercase`}

  span {
    ${tw`text-yellow`}
  }
`

const ImgContainer = styled.div<{ isRtl: boolean }>`
  ${tw`absolute top-0 w-3/4 lg:w-1/2`}
  ${({ isRtl }) => (isRtl ? tw`left-0` : tw`right-0`)}
  transform:translateZ(0);
`

const StyledImg = styled(Img)`
  ${tw`left-0`}
  z-index: -1;
  transform: translate(50px, -100px);
`

const Description = styled.p`
  ${tw`my-10`}
  max-width: 25rem;
`

const TilesList = styled.ul`
  ${tw`grid grid-flow-row lg:grid-flow-col lg:gap-12`}
  align-items: stretch;
  grid-auto-columns: 1fr;
`

const WhatWeDo: FunctionComponent<{ services: Services }> = ({ services }) => {
  const sectionRef = useRef(null)
  const { sectionRef: tilesContainerRef, tilesRefs } = useTilesStagger()

  return !services || services.length === 0 ? null : (
    <WhatWeDoSection>
      <AnchorToGoTo id="whatwedo" />
      <Container>
        <WhatWeDoContent ref={sectionRef}>
          <TilesList ref={tilesContainerRef}>
            {services.map((tile, i) => (
              <li key={tile.id}>
                <HomeTile ref={e => (tilesRefs.current[i] = e)} tile={tile} />
              </li>
            ))}
          </TilesList>
        </WhatWeDoContent>
      </Container>
    </WhatWeDoSection>
  )
}

export default WhatWeDo
